import * as React from 'react';
import './PageBroken.scss';
const PageBroken = ({ text = '' }) => (React.createElement("header", { className: "page-broken" },
    React.createElement("div", { className: "page-broken-inner" },
        React.createElement("p", null, "Page broken image"),
        React.createElement("p", null, text || 'Somthing went wrong'),
        React.createElement("p", null, "Reload"),
        React.createElement("p", null, "Report"))));
export default PageBroken;
